import { toggleSingleSceneObject } from "../../togglers";
import { OFFSET_GLIDERS } from "./pos_map";

export const changeNozhkiStula = (isChecked) => {
    const name = "stul__sta__nozhki";

    const isOporaGlaydery = servObj.activeOpora.some((opora) => opora.userData.type === "glaydery");
    const position = isOporaGlaydery ? { y: 10 - OFFSET_GLIDERS.Y } : { y: 10 };

    toggleSingleSceneObject({
        allObjects: servObj.allNozhkiStula,
        activeArray: servObj.activeNozhkiStula,
        name,
        isChecked,
        position,
        userData: { name },
    });
};
